(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-images"] && !Shopify.designMode) return;
  try {
    (function() {
  function initGallery(galleryEl) {
    if (!galleryEl || galleryEl.dataset.swiperWired === 'true') return;
    if (typeof Swiper === 'undefined') {
      setTimeout(function() { initGallery(galleryEl); }, 50);
      return;
    }
    galleryEl.dataset.swiperWired = 'true';

    var sectionId = galleryEl.getAttribute('data-section-id');
    var mainEl = galleryEl.querySelector('.product-gallery__main');
    var thumbsEl = galleryEl.querySelector('.product-gallery__thumbs');
    var thumbPosition = galleryEl.getAttribute('data-thumb-position') || 'below';

    if (!mainEl) return;

    var thumbsSwiper = null;
    if (thumbsEl) {
      var thumbsWrap = thumbsEl.parentElement;
      var thumbPrev = thumbsWrap ? thumbsWrap.querySelector('.product-gallery__thumb-nav--prev') : null;
      var thumbNext = thumbsWrap ? thumbsWrap.querySelector('.product-gallery__thumb-nav--next') : null;
      thumbsSwiper = new Swiper(thumbsEl, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        watchSlidesProgress: true,
        freeMode: true,
        slideToClickedSlide: true,
        navigation: thumbPrev && thumbNext ? {
          prevEl: thumbPrev,
          nextEl: thumbNext,
        } : false,
        direction: thumbPosition === 'beside' && window.matchMedia('(min-width: 750px)').matches ? 'vertical' : 'horizontal',
        breakpoints: thumbPosition === 'beside' ? {
          750: { direction: 'vertical' },
        } : undefined,
      });
    }

    // autoHeight lets the main gallery shrink to each slide's real image
    // height instead of locking to one aspect-ratio box. Without it, images
    // with different ratios get letterboxed and a tall empty gap appears
    // between the photo and the thumbnail row (most visible on mobile).
    var mainSwiper = new Swiper(mainEl, {
      speed: 400,
      loop: false,
      grabCursor: true,
      autoHeight: true,
      observer: true,
      observeParents: true,
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
      a11y: {
        prevSlideMessage: 'Previous image',
        nextSlideMessage: 'Next image',
      },
    });

    // On first (uncached) load the product images aren't decoded yet, so at
    // init Swiper (a) locks in a wrong autoHeight and (b) can misread the
    // container width and lay the thumbnails out in the WRONG direction
    // (vertical on mobile) — it only looks right after a reload once images
    // are cached. Fix: after each image loads (plus on window `load` and a
    // rAF) re-run update() AND force the correct thumbnail direction for the
    // current viewport, so it self-corrects without needing a refresh.
    function correctThumbDirection() {
      if (!thumbsSwiper || thumbsSwiper.destroyed) return;
      var wantVertical = thumbPosition === 'beside' && window.matchMedia('(min-width: 750px)').matches;
      var want = wantVertical ? 'vertical' : 'horizontal';
      if (thumbsSwiper.params.direction !== want && typeof thumbsSwiper.changeDirection === 'function') {
        thumbsSwiper.changeDirection(want);
      }
      thumbsSwiper.update();
    }
    function recalc() {
      correctThumbDirection();
      if (!mainSwiper || mainSwiper.destroyed) return;
      mainSwiper.update();
      if (typeof mainSwiper.updateAutoHeight === 'function') {
        mainSwiper.updateAutoHeight(0);
      }
    }
    mainEl.querySelectorAll('img').forEach(function(img) {
      if (img.complete && img.naturalHeight !== 0) return;
      img.addEventListener('load', recalc, { once: true });
      img.addEventListener('error', recalc, { once: true });
    });
    // Belt-and-suspenders: recalc after full page load, a rAF, and on resize.
    window.addEventListener('load', recalc, { once: true });
    requestAnimationFrame(recalc);
    var galResizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(galResizeTimer);
      galResizeTimer = setTimeout(recalc, 200);
    });

    // Listen for variant changes (legacy `theme.Variants` dispatches with
    // detail.variant; new <variant-picker> dispatches with detail.variant
    // and detail.featured_media_id). Accept both shapes — slide to the
    // featured media for the new variant.
    document.addEventListener('variant:change', function(e) {
      if (!e.detail) return;
      var featuredId = e.detail.featured_media_id;
      if (!featuredId && e.detail.variant) {
        var variant = e.detail.variant;
        if (variant.featured_media && variant.featured_media.id) {
          featuredId = variant.featured_media.id;
        } else if (variant.featured_image && variant.featured_image.id) {
          /* legacy `featured_image.id` is the IMAGE id, not the media id.
             Translate by finding the slide whose `data-media-id` matches a
             media whose preview_image.id equals this image id. As a quick
             approximation, match by image position (legacy image.position is
             1-indexed; our slides use 0-based data-index). */
          var pos = variant.featured_image.position;
          if (typeof pos === 'number' && pos > 0) {
            var slidesByIdx = mainEl.querySelectorAll('.swiper-slide');
            if (slidesByIdx[pos - 1]) {
              mainSwiper.slideTo(pos - 1);
              return;
            }
          }
        }
      }
      if (!featuredId) return;
      var slides = mainEl.querySelectorAll('.swiper-slide');
      var idx = -1;
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(featuredId)) {
          idx = i;
          break;
        }
      }
      if (idx !== -1) mainSwiper.slideTo(idx);
    });

    // Zoom dialog
    if (galleryEl.getAttribute('data-zoom') === 'true') {
      var dialog = galleryEl.querySelector('.product-gallery__zoom');
      if (dialog) {
        var zoomImg = dialog.querySelector('.product-gallery__zoom-image');
        var closeBtn = dialog.querySelector('.product-gallery__zoom-close');

        galleryEl.querySelectorAll('.product-gallery__image').forEach(function(img) {
          img.addEventListener('click', function() {
            zoomImg.src = img.getAttribute('data-zoom-src') || img.currentSrc || img.src;
            zoomImg.alt = img.alt || '';
            if (typeof dialog.showModal === 'function') dialog.showModal();
          });
        });

        closeBtn && closeBtn.addEventListener('click', function() { dialog.close(); });
        dialog.addEventListener('click', function(e) {
          if (e.target === dialog) dialog.close();
        });
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-product-gallery]').forEach(initGallery);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function(e) {
    if (!e.target) return;
    e.target.querySelectorAll('[data-product-gallery]').forEach(function(gallery) {
      /* Fresh DOM after section reload — reset the wired guard. */
      var mainEl = gallery.querySelector('.product-gallery__main');
      var thumbsEl = gallery.querySelector('.product-gallery__thumbs');
      if (mainEl && mainEl.swiper) { try { mainEl.swiper.destroy(true, true); } catch (err) {} }
      if (thumbsEl && thumbsEl.swiper) { try { thumbsEl.swiper.destroy(true, true); } catch (err) {} }
      gallery.dataset.swiperWired = '';
      initGallery(gallery);
    });
  });
  document.addEventListener('shopify:section:unload', function(e) {
    if (!e.target) return;
    e.target.querySelectorAll('[data-product-gallery]').forEach(function(gallery) {
      var mainEl = gallery.querySelector('.product-gallery__main');
      var thumbsEl = gallery.querySelector('.product-gallery__thumbs');
      if (mainEl && mainEl.swiper) { try { mainEl.swiper.destroy(true, true); } catch (err) {} }
      if (thumbsEl && thumbsEl.swiper) { try { thumbsEl.swiper.destroy(true, true); } catch (err) {} }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
